import ManufacturerForm from './ManufacturerForm';

export default ManufacturerForm;
export * from './ManufacturerForm';
